import {
	ProductActionsType,
	SET_ALL_CUSTOMERS,
	SET_ALL_PRODUCTS,
	SET_SELECTED_PRODUCT,
	SET_TOP_SELLERS,
	SET_UPLOAD_URL,
	// ADD_TO_CART,
	TopProductSellers
} from "../types/actions/ProductAction";

export type InitialState = {
	topSellers: Array<TopProductSellers> | null
	allCustomers: any;
	products: any | null
	selectedProduct: any | null
	cartItems: Array<any>
	imageUrl: string | null
}

const initialState: InitialState = {
	topSellers: null,
	allCustomers: null,
	products: null,
	selectedProduct: null,
	cartItems: [],
	imageUrl: null
}

const productReducer = (state = initialState, action: ProductActionsType) => {
	switch (action.type) {
		case SET_TOP_SELLERS:
			return {
				...state,
				topSellers: action.payload
			}
		case SET_ALL_CUSTOMERS:
			return {
				...state,
				allCustomers: action.payload
			}
		case SET_ALL_PRODUCTS:
			return {
				...state,
				products: action.payload
			}
		case SET_SELECTED_PRODUCT:
			return {
				...state,
				selectedProduct: action.payload
			}
		case SET_UPLOAD_URL:
			return {
				...state,
				imageUrl: action.payload
			}
		// case ADD_TO_CART:
		// 	return {
		// 		...state,
		// 		selectedProduct: '', // action.payload.cartItem
		// 	}
		default:
			return state;
  	}
};

export default productReducer;
